function pad2(num) {
  if (num > -1 && num < 10) {
    return "0" + num;
  }
  return "" + num;
}

export function formatDate(IsoDateString) {
  const date = new Date(IsoDateString);
  return `${pad2(date.getDate())} - ${pad2(date.getMonth() + 1)} - ${date.getFullYear()}`;
}

export function formatTime(IsoDateString) {
  const date = new Date(IsoDateString);
  return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

export function formatDateTime(IsoDateString) {
  const date = new Date(IsoDateString);
  return `${pad2(date.getDate())} - ${pad2(date.getMonth() + 1)} - ${date.getFullYear()} / ${formatTime(date)}`;
}

export function formatDateLong(IsoDateString) {
  const date = new Date(IsoDateString);
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return `${date.toLocaleString('nl-NL', options)}`;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js